/** @jsxImportSource @emotion/react */
import { createStyles, useTheme } from '@quickbit/qb-design-system';
import { useNavigate } from 'react-router-dom';

export type StepTypes = { basePath: string, path: string; label: string };

export const Steps = ({
  steps,
  currentStepIndex,
}: {
  steps: StepTypes[];
  currentStepIndex: number;
}) => {
  const styles = useStyles();
  const { palette, spacing } = useTheme();
  const navigate = useNavigate();
  return (
    <div css={styles.container}>
      {steps.map((step, index) => (
        <div
          key={step.path}
          css={[
            styles.step,
            index === currentStepIndex && {
              fontWeight: 'bold',
              color: `${palette.grey.x500}`,
              borderBottom: `6px solid ${palette.grey.x500}`,
            },
          ]}
        >
          <div
            css={{
              margin: `${spacing.xxxs} ${spacing.xs} 0`,
              cursor: 'pointer',
            }}
            onClick={() =>
              navigate(`${step.basePath}/${step.path}${window.location.search}`)
            }
          >
            {step.label}
          </div>
        </div>
      ))}
    </div>
  );
};

const useStyles = createStyles(({ spacing, palette, breakpoints }) => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    [breakpoints.tabletSmall]: {
      flexDirection: 'row',
    },
  },
  step: {
    color: '#888',
    marginRight: spacing.xxxs,
    borderBottom: `4px solid ${palette.grey.x100}`,
  },
}));
